module.exports = __webpack_public_path__ + "static/media/software-development.d83f8d97.svg";